import { call, put, select, takeLatest } from "redux-saga/effects";

import * as BotpressAPI from "../../data/api/omniBotpressAPI.js";
import { createOmniPaginationObject } from "../../utils/helpers";
import { deepCopyObject, helperGetIsoDate } from "../../utils/helpers.js";
import * as UserSessionStorage from "../../utils/userSessionStorage";
import * as Actions from "../redux/botpressSession";

export function* setBotpressBotODM({ payload }) {
  try {
    //get the current and clear it out

    if (payload != null) {
      const botId = payload.omniData.botId;
      yield call(UserSessionStorage.storeLastBotpressBotID, botId);
    }

    yield put(Actions.setBotpressBotODMSuccess(payload));

    //The subsequent methods may not have the state/date set yet, so we grab it ourselves
    const startDate = yield select(Actions.analyticsStartDateSelector);
    let theParameters = {
      botODM: payload,
      analyticsStartDate: startDate,
    };
    yield put(Actions.loadAnalyticsRequest(theParameters));
    yield put(Actions.loadBotRequest(theParameters));
    yield put(Actions.loadBotpressSummaryRequest(theParameters));

    // //Tables load this via pagination when needed
    // const chatPage = yield select(Actions.chatPaginationSelector);
    // chatPage["botODM"] = payload;
    // yield put(Actions.searchChatsRequest(chatPage));

    //load feedback
    const feedbackPage = yield select(Actions.feedbackPaginationSelector);
    feedbackPage["botODM"] = payload;
    yield put(Actions.searchFeedbackRequest(feedbackPage));

    //load assessment
    const assessmentPage = yield select(Actions.assessmentPaginationSelector);
    assessmentPage["botODM"] = payload;
    yield put(Actions.searchAssessmentRequest(assessmentPage));
  } catch (error) {
    yield put(Actions.loadAnalyticsRequest(null));
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setAnalyticsBotODM({ payload }) {
  try {
    //get the current and clear it out
    yield put(Actions.setAnalyticsBotODMSuccess(payload));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadAnalytics({ payload }) {
  try {
    const yesterdayEverythingSeemedSoFarAway = new Date(helperGetIsoDate(1, true, true)); //today but start of the day
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const startDate =
      payload.analyticsStartDate != null
        ? new Date(payload.analyticsStartDate)
        : yesterdayEverythingSeemedSoFarAway;
    const currentAnalytics = yield select(Actions.analyticsSelector);
    const currentStartDate = yield select(Actions.analyticsStartDateSelector);

    //check the date?
    if (!currentAnalytics || startDate < currentStartDate) {
      const botpressBotODM =
        payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

      if (botpressBotODM == null) {
        yield put(
          Actions.loadAnalyticsSuccess({
            analytics: null,
            analyticsStartDate: startDate,
          }),
        );
        return;
      }

      //today
      const endDate = new Date(helperGetIsoDate(0, false, true)); //today

      if (botpressBotODM != null) {
        let theParameters = {
          botODM: botpressBotODM,
          analyticsStartDate: startDate,
          analyticsEndDate: endDate,
        };
        let theReturn = yield call(BotpressAPI.getBotAnalytics, theParameters);
        yield put(
          Actions.loadAnalyticsSuccess({
            analytics: theReturn.records,
            analyticsStartDate: startDate,
          }),
        );
      }
    } else {
      //data is already there, they asked for less than we have
      yield put(
        Actions.loadAnalyticsSuccess({
          analytics: currentAnalytics,
          analyticsStartDate: currentStartDate,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadBot({ payload }) {
  try {
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      let theParameters = {
        botODM: botpressBotODM,
      };
      let theReturn = yield call(BotpressAPI.getBot, theParameters);
      yield put(Actions.loadBotSuccess(theReturn.bot));
    } else {
      yield put(Actions.loadBotSuccess(null));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* loadBotpressSummary({ payload }) {
  try {
    //All this shit is to handler initialization, you can pass in empty payloads after setting the bot
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      let theParameters = {
        botODM: botpressBotODM,
      };
      let theReturn = yield call(BotpressAPI.getBotpressSummary, theParameters);
      yield put(Actions.loadBotpressSummarySuccess(theReturn));
    } else {
      yield put(Actions.loadBotpressSummarySuccess(null));
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* searchChats({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (botpressBotODM != null) {
      const currentPagination = yield select(Actions.chatPaginationSelector);
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let chatPages = yield select(Actions.chatPagesSelector);
      if (!currentCacheInvalid && chatPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        console.log("BotpressSession: Already Have Row:  " + payload.pageIndex);

        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(chatPages).length;
        const lastPageLength = chatPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchChatsSuccess({
            chatPages: chatPages,
            chats: chatPages[payload.pageIndex].odms,
            chatPagination: payload,
          }),
        );
      } else {
        // //Old Way of doing things
        // payload["botODM"] = botpressBotODM;
        // let theReturn = yield call(BotpressAPI.searchConversations, payload);
        // //upate the currentPagination
        // payload.totalItems = payload.pageIndex * payload.pageSize + theReturn.rows.length;
        // if (theReturn.hasMore) {
        //   //assumes payload is full fo rthe pageSize if true
        //   payload.totalItems += 1; //to indicate more items
        // }

        // if (currentCacheInvalid) {
        //   chatPages = {};
        // }
        // chatPages[payload.pageIndex] = { odms: theReturn.rows };

        // yield put(
        //   Actions.searchChatsSuccess({
        //     chatPages: chatPages,
        //     chats: theReturn.rows,
        //     chatPagination: payload,
        //   }),
        // );

        console.log("BotpressSession: Reloading:  " + payload.pageIndex);
        let newChatPages = {};
        let tmpPayload = deepCopyObject(payload);
        tmpPayload["botODM"] = botpressBotODM;
        let hasMore = true;
        let index = 0;
        for (; hasMore; index++) {
          tmpPayload.pageIndex = index;
          let theReturn = yield call(BotpressAPI.searchConversations, tmpPayload);
          //upate the currentPagination
          newChatPages[index] = { odms: theReturn.rows };
          hasMore = theReturn.hasMore;
        }

        --index;
        payload.totalItems = index * payload.pageSize + newChatPages[index].odms.length;

        yield put(
          Actions.searchChatsSuccess({
            chatPages: newChatPages,
            chats: newChatPages[payload.pageIndex]?.odms || [],
            chatPagination: payload,
          }),
        );

        yield put(Actions.analyzeChatsRequest(newChatPages));
      }
    } else {
      console.log("BotpressSession: empty response:  " + payload.pageIndex);
      yield put(
        Actions.searchChatsSuccess({
          chatPages: {},
          chats: [],
          chatPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* analyzeChats({ payload }) {
  try {
    // const chatPages = payload != null ? payload : yield select(Actions.chatPagesSelector);
    const chatPages = payload;
    const pageCount = Object.keys(chatPages).length;

    //TODO standardize this..
    let theResults = {
      topicFrequency: [],
    };

    const frequencyMap = new Map();
    const sentimentMap = new Map();

    for (let pageIndex = 0; pageIndex < pageCount; ++pageIndex) {
      for (let rowIndex = 0; rowIndex < chatPages[pageIndex].odms.length; ++rowIndex) {
        let currentRow = chatPages[pageIndex].odms[rowIndex];
        if (currentRow.topics != null) {
          for (let topicIndex = 0; topicIndex < currentRow.topics.length; ++topicIndex) {
            let theTopic = currentRow.topics[topicIndex];
            frequencyMap.set(theTopic, (frequencyMap.get(theTopic) || 0) + 1);
          }
        }
        if (currentRow.sentiment != null) {
          sentimentMap.set(currentRow.sentiment, (sentimentMap.get(currentRow.sentiment) || 0) + 1);
        }
      }
    }

    const sortedMapDesc = new Map([...frequencyMap].sort((a, b) => b[1] - a[1]));
    theResults["topicFrequency"] = sortedMapDesc;

    const sortedSentimentMap = new Map([...sentimentMap].sort((a, b) => b[1] - a[1]));
    theResults["sentimentFrequency"] = sortedSentimentMap;

    yield put(Actions.analyzeChatsSuccess(theResults));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteChat({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.conversationId != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteConversation, payload);

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const chatPage = yield select(Actions.chatPaginationSelector);
        //setting the botODM triggers reload
        chatPage["botODM"] = botpressBotODM;

        yield put(Actions.searchChatsRequest(chatPage));
      }
    }
    //reload
    Actions.deleteChatSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* searchFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    const currentPagination = yield select(Actions.feedbackPaginationSelector);
    if (botpressBotODM != null) {
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let feedbackPages = yield select(Actions.feedbackPagesSelector);
      if (!currentCacheInvalid && feedbackPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(feedbackPages).length;
        const lastPageLength = feedbackPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchFeedbackSuccess({
            feedbackPages: feedbackPages,
            feedback: feedbackPages[payload.pageIndex].odms,
            feedbackPagination: payload,
          }),
        );
      } else {
        payload["botODM"] = botpressBotODM;
        let theReturn = yield call(BotpressAPI.searchFeedback, payload);
        //upate the currentPagination
        payload.totalItems = payload.pageIndex * payload.pageSize + theReturn.rows.length;
        if (theReturn.hasMore) {
          //assumes payload is full fo rthe pageSize if true
          payload.totalItems += 1; //to indicate more items
        }

        if (currentCacheInvalid) {
          feedbackPages = {};
        }
        feedbackPages[payload.pageIndex] = { odms: theReturn.rows };

        yield put(
          Actions.searchFeedbackSuccess({
            feedbackPages: feedbackPages,
            feedback: theReturn.rows,
            feedbackPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchFeedbackSuccess({
          feedbackPages: {},
          feedback: [],
          feedbackPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.feedbackRecord != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = null;
      if (payload.feedbackRecord.id == null) {
        theReturn = yield call(BotpressAPI.addFeedback, payload);
      } else {
        theReturn = yield call(BotpressAPI.updateFeedback, payload);
      }

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const feedbackPage = yield select(Actions.feedbackPaginationSelector);
        //setting the botODM triggers reload
        feedbackPage["botODM"] = botpressBotODM;
        yield put(Actions.searchFeedbackRequest(feedbackPage));
      }
    }

    //reload
    Actions.updateFeedbackSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteFeedback({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.feedbackId != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteFeedback, payload);
      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const feedbackPage = yield select(Actions.feedbackPaginationSelector);
        //setting the botODM triggers reload
        feedbackPage["botODM"] = botpressBotODM;
        yield put(Actions.searchFeedbackRequest(feedbackPage));
      }
    }

    //reload
    Actions.deleteFeedbackSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//#region Assessment

export function* searchAssessment({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    const currentPagination = yield select(Actions.assessmentPaginationSelector);
    if (botpressBotODM != null) {
      //payload is a "currentPagination" from helpers.js
      let currentCacheInvalid = false;
      if (
        payload.pageSize !== currentPagination.pageSize ||
        JSON.stringify(payload.query) !== JSON.stringify(currentPagination.query) ||
        JSON.stringify(payload.sort) !== JSON.stringify(currentPagination.sort) ||
        payload.botODM != null
      ) {
        //something fundamental has changed
        currentCacheInvalid = true;
      }
      let assessmentPages = yield select(Actions.assessmentPagesSelector);
      if (!currentCacheInvalid && assessmentPages.hasOwnProperty(payload.pageIndex)) {
        //FML
        payload["botODM"] = botpressBotODM;
        const propertyCount = Object.keys(assessmentPages).length;
        const lastPageLength = assessmentPages[propertyCount - 1].odms.length;
        payload.totalItems = (propertyCount - 1) * payload.pageSize + lastPageLength;
        if (lastPageLength === payload.pageSize) {
          payload.totalItems += 1; //to indicate more items
        }
        yield put(
          Actions.searchAssessmentSuccess({
            assessmentPages: assessmentPages,
            assessment: assessmentPages[payload.pageIndex].odms,
            assessmentPagination: payload,
          }),
        );
      } else {
        payload["botODM"] = botpressBotODM;
        let theReturn = yield call(BotpressAPI.searchAssessment, payload);
        //upate the currentPagination
        payload.totalItems = payload.pageIndex * payload.pageSize + theReturn.rows.length;
        if (theReturn.hasMore) {
          //assumes payload is full fo rthe pageSize if true
          payload.totalItems += 1; //to indicate more items
        }

        if (currentCacheInvalid) {
          assessmentPages = {};
        }
        assessmentPages[payload.pageIndex] = { odms: theReturn.rows };

        yield put(
          Actions.searchAssessmentSuccess({
            assessmentPages: assessmentPages,
            assessment: theReturn.rows,
            assessmentPagination: payload,
          }),
        );
      }
    } else {
      yield put(
        Actions.searchAssessmentSuccess({
          assessmentPages: {},
          assessment: [],
          assessmentPagination: payload,
        }),
      );
    }
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* updateAssessment({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.assessmentRecord != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = null;
      if (payload.assessmentRecord.id == null) {
        theReturn = yield call(BotpressAPI.addAssessment, payload);
      } else {
        theReturn = yield call(BotpressAPI.updateAssessment, payload);
      }

      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const assessmentPage = yield select(Actions.assessmentPaginationSelector);
        //setting the botODM triggers reload
        assessmentPage["botODM"] = botpressBotODM;
        yield put(Actions.searchAssessmentRequest(assessmentPage));
      }
    }

    //reload
    Actions.updateAssessmentSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* deleteAssessment({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload.botODM != null ? payload.botODM : yield select(Actions.botpressBotODMSelector);

    if (payload.assessmentId != null) {
      //delete the chat
      payload["botODM"] = botpressBotODM;
      let theReturn = yield call(BotpressAPI.deleteAssessment, payload);
      if (Object.hasOwn(theReturn, "code")) {
        yield put(Actions.botpressSessionRequestFailed(theReturn));
      } else {
        const assessmentPage = yield select(Actions.assessmentPaginationSelector);
        //setting the botODM triggers reload
        assessmentPage["botODM"] = botpressBotODM;
        yield put(Actions.searchAssessmentRequest(assessmentPage));
      }
    }

    //reload
    Actions.deleteAssessmentSuccess({});
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//#endregion
export function* loadConversation({ payload }) {
  try {
    //payload is a "pagination" from helpers.js
    const botpressBotODM =
      payload && payload.botODM != null
        ? payload.botODM
        : yield select(Actions.botpressBotODMSelector);

    if (payload != null) {
      const credentialedPayload = { botODM: botpressBotODM, conversationId: payload };
      const theMessages = yield call(BotpressAPI.loadConversation, credentialedPayload);
      //load feedback

      const newPage = createOmniPaginationObject(null, 50);
      newPage.pageIndex = 0;
      newPage.sort = { createdAt: "desc" };
      newPage.query = { conversationId: payload };
      newPage["botODM"] = botpressBotODM;

      const feeedbackRecords = yield call(BotpressAPI.searchFeedback, newPage);

      yield put(
        Actions.loadConversationSuccess({
          conversationId: payload,
          conversation: theMessages,
          conversationFeedback: feeedbackRecords.rows,
        }),
      );
    } else {
      //reset it, null payload
      yield put(
        Actions.loadConversationSuccess({
          conversationId: null,
          conversation: null,
          conversationFeedback: null,
        }),
      );
    }
    // //reload
    // Actions.loadConversationSuccess(payload);
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

export function* setBotAssessmentState({ payload }) {
  try {
    let theParameters = {
      conversationId: payload.conversationId,
      userKey: payload.userKey,
    };

    yield put(Actions.setBotAssessmentStateSuccess(theParameters));
  } catch (error) {
    yield put(Actions.botpressSessionRequestFailed(error));
  }
}

//  saga
export default function* userSessionSaga() {
  yield takeLatest(Actions.setBotpressBotODMRequest, setBotpressBotODM);
  yield takeLatest(Actions.setAnalyticsBotODMRequest, setAnalyticsBotODM);
  yield takeLatest(Actions.loadAnalyticsRequest, loadAnalytics);
  yield takeLatest(Actions.loadBotpressSummaryRequest, loadBotpressSummary);
  yield takeLatest(Actions.loadBotRequest, loadBot);
  yield takeLatest(Actions.searchChatsRequest, searchChats);
  yield takeLatest(Actions.analyzeChatsRequest, analyzeChats);
  yield takeLatest(Actions.deleteChatRequest, deleteChat);
  yield takeLatest(Actions.searchFeedbackRequest, searchFeedback);
  yield takeLatest(Actions.updateFeedbackRequest, updateFeedback);
  yield takeLatest(Actions.deleteFeedbackRequest, deleteFeedback);
  yield takeLatest(Actions.searchAssessmentRequest, searchAssessment);
  yield takeLatest(Actions.updateAssessmentRequest, updateAssessment);
  yield takeLatest(Actions.deleteAssessmentRequest, deleteAssessment);

  yield takeLatest(Actions.loadConversationRequest, loadConversation);
  yield takeLatest(Actions.setBotAssessmentStateRequest, setBotAssessmentState);
}
